<template>
  <button :class="{wide}">
    <span>{{text}}</span>
    <img v-if="color == 'white'" src="@/assets/PlusWhite.svg"/>
    <img v-if="color == 'green'" src="@/assets/PlusGreen.svg"/>
  </button>
</template>

<script>
  export default {
    name: "AddButton",
    props:{
      text:{ type: String, default:'' },
      color:{ type: String, default: 'white' },
      wide:{ type: Boolean, default: false }
  }
}
</script>

<style scoped>
.wide {
  width: 100%;
}
.wide span {
  flex: 1;
  text-align: left;
}
</style>
